import styled from 'styled-components';


export const SearchContainer = styled.div`
  position: relative;
  width: 300px;
  margin-left: 15px;
  @media (max-width: 768px) {
    width: auto;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 16px;
  box-sizing: border-box;

  &:focus {
    border-color: #ff0000;
  }
`;

export const ResultsBox = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1001;
  border-radius: 4px;
`;

export const ResultItem = styled.div`
  display: flex;
  padding: 15px;
  align-items: center;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    border-radius: 5px;
    background-color: #f0f0f0;
  }
`;

export const ResultItemLi = styled.li`
  margin-left: 15px;
`;
